import { Entry } from '../Entry'

export function Entry20250422() {
  return (
    <Entry title="2025 Apr 22 - v3.10.9">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/17776/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
